import type { ReactNode } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb as BreadcrumbCore } from 'react-bootstrap'

export type BreadcrumbItem = {
  name?: string
  url?: string
  path?: string
  component?: ReactNode
}

export type BreadcrumbProps = { items?: BreadcrumbItem[] }

export const Breadcrumb = ({ items = [] }: BreadcrumbProps) => {
  return (
    <BreadcrumbCore>
      {items.map((m, i) => {
        let content = <strong>{m.component ?? m.name}</strong>
        if ((m.url || m.path) && i !== items.length - 1) {
          content = <Link to={m.url || m.path}>{m.component ?? m.name}</Link>
        }

        return (
          // d-flex: Bootstrap floats the "/" separator, and an item holding a block-level row (a detail
          // page's status + code HorizontalStack) is sized without that float, which then takes its width
          // from the row. As a flex row the separator is an item and counts.
          <BreadcrumbCore.Item linkAs="span" key={i} className="d-flex">
            {content}
          </BreadcrumbCore.Item>
        )
      })}
    </BreadcrumbCore>
  )
}
